import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';

// ts-expect-error queryKey
export const getInvoicePaymentMethods = async ({ queryKey }: QueryFunctionContext<[string, number]>) => {
  const { data } = await baseQuery(`invoice-payment-methods?job_id=${queryKey[1]} `);

  return data;
};
